import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';


export const initI18n = async () => {
	const userLang = navigator.language || navigator.userLanguage

	let userLanguageCode = ""
	if(userLang){
		userLanguageCode = userLang.split("-")[0].toUpperCase()
	}

	const languageCode = userLanguageCode || "EN"

	await i18n
		.use(initReactI18next)
		.use(HttpBackend)
		.init({
			backend: {
				loadPath: '/locales/{{lng}}/{{ns}}.json',
			},
			lng: languageCode,
			fallbackLng: userLanguageCode || 'EN',
			ns: ['common'], // Default namespace, can be expanded dynamically
			interpolation: {
				escapeValue: false,
			},
			react: {
				useSuspense: false,
			},
			load: 'currentOnly',
			preload: userLanguageCode ? [userLanguageCode, 'ID'] : ['EN'],
		})

	return i18n
}

export const changeLanguage = (language) => {
	i18n.changeLanguage(language).then(() => {
		console.log(`Language changed to ${language}`)
	}).catch((error) => {
		console.error('Error changing language:', error)
	})
}

initI18n().then(() => {
	console.log('i18n initialized')
})

export default i18n;